import React from "react";
import { Button, IconButton } from "@src/components";
import { INVALID_VALUE } from "@src/constants/InvalidValue";
import DropDown from "@src/components/select/DropDown";

interface PaidBenefitOption {
    key: string;
    value: string;
}

export const getColumns = (
    navigate: any,
    openBenefitsProductModal?: (partnerRow: any) => void,
    paidBenefitsOptions: PaidBenefitOption[] = [],
    onSelectPaidBenefits?: (partnerRow: any, benefitNo: number | null) => void,
    getPaidBenefitDefaultValue?: (partnerRow: any) => string,
    onDeleteRegisterBenefits?: (partnerRow: any) => void,
) => [
    {
        id: "1",
        Header: "파트너 번호",
        accessor: "paybackPartnerNo",
        Cell: ({ cell: { value } }: any) => <div>{value ? value : INVALID_VALUE}</div>,
    },
    {
        id: "2",
        Header: "이름",
        accessor: "userName",
        Cell: ({ cell: { value }, row }: any) => {
            const name = row.original.user.info.uname;
            const id = row.original.user.no;
            return (
                <div
                    onClick={() => {
                        navigate(`/users/detail/${id}`);
                    }}
                >
                    {name ? name : INVALID_VALUE}
                </div>
            );
        },
    },
    {
        id: "3",
        Header: "닉네임",
        accessor: "partnerName",
        Cell: ({ cell: { value } }: any) => {
            return <div>{value ? value : INVALID_VALUE}</div>;
        },
    },
    {
        id: "4",
        Header: "파트너코드",
        accessor: "partnerCode",
        Cell: ({ cell: { value } }: any) => {
            return <div>{value ? value : INVALID_VALUE}</div>;
        },
    },

    {
        id: "5",
        Header: "가입 시 무료 이용 이용권",
        accessor: "registerProductName",
        Cell: ({ cell: { value }, row }: any) => {
            return (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                    {value ? <span>{value}</span> : null}
                    <Button
                        label={value ? "수정" : "추가"}
                        color="gd"
                        handleClick={() => {
                            openBenefitsProductModal?.(row.original);
                        }}
                        size="small"
                    />
                    {value ? (
                        <Button
                            label="삭제"
                            color="white"
                            handleClick={() => {
                                onDeleteRegisterBenefits?.(row.original);
                            }}
                            size="small"
                            styles={{ marginLeft: 0 }}
                        />
                    ) : null}
                </div>
            );
        },
    },
    {
        id: "6",
        Header: "(추천인 코드 입력 후) 유료 상품 구매 시 추가 이용권",
        accessor: "paymentProductName",
        Cell: ({ cell: { value }, row }: any) => {
            const paidBenefitsDropDownOptions = [{ key: "", value: "선택안함" }, ...paidBenefitsOptions];
            const selectedByState = getPaidBenefitDefaultValue?.(row.original) ?? "";
            const selectedByServer = paidBenefitsOptions.find((option) => option.value === value)?.key ?? "";
            const defaultValue = selectedByState || selectedByServer;

            return (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 8 }}>
                    <DropDown
                        data={paidBenefitsDropDownOptions}
                        handleChange={(_, __, value) => {
                            const parsed = value && value !== "undefined" ? Number(value) : null;
                            onSelectPaidBenefits?.(row.original, Number.isNaN(parsed) ? null : parsed);
                        }}
                        defaultValue={defaultValue}
                        handleBannerChange={() => {}}
                        border={true}
                        isDisabled={false}
                        label="선택"
                    />
                </div>
            );
        },
    },
    {
        id: "7",
        Header: "관리",
        accessor: "no",
        Cell: ({ cell: { value, row } }: any) => {
            const no = row.original.no;
            return (
                <div>
                    <IconButton
                        type="arrow"
                        handleClick={() => {
                            navigate(`/partner/detail/${no}`, {
                                state: {
                                    no: no,
                                },
                            });
                        }}
                    />
                </div>
            );
        },
    },
];
